import Crud from '../views/PesquisaUnidade/Crud'

let routes = {
    path: '/pesquisa-unidade',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/pesquisa-unidade',
            name: 'list-pesquisa-unidade',
            component: Crud,
            meta: {
                pageTitle: 'Pesquisa por Unidade',
                breadcrumb: [
                    {
                        text: 'Pesquisa por Unidade',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes